<template lang="html">
  <walkthrough-stepper
    @close="$emit('close')"
    :pageTitles="page_titles"
    stepperTitle="Submissions and Assessment"
  >
    <template slot-scope="{ page }">
      <div class="mh3 pa3 flex-grow" v-show="page === 0">
        <div class="flex justify-center mb2">
          <i class="far fa-comment-alt fa-3x ma3"></i>
        </div>
        <p class="pl-subheading tl">
          Each student submits a unique response to the prompt before joining
          the discussion. Responses can include text, images, videos and
          hyperlinks.
        </p>
      </div>
      <div class="mh3 pa3 flex-grow" v-show="page === 1">
        <div class="flex justify-center mb2">
          <i class="fas fa-clipboard-list fa-3x ma3" />
        </div>
        <p class="pl-subheading tl">
          Click on the <span class="italics">Assessment Tab</span> in the
          submission card to read student posts, provide feedback and see a
          summary of all the comments they made during the RoundTable.
        </p>
      </div>
    </template>
  </walkthrough-stepper>
</template>
<script>
  import WalkthroughStepper from 'features/onlineWalkthrough/onlineWalkthroughStepper';

  export default {
    data() {
      return {
        page_titles: ['Submission', 'Assessment'],
      };
    },
    components: {
      WalkthroughStepper,
    },
  };
</script>
<style scoped lang="stylus">
  @import '~app/global-stylus.styl'
</style>
<!--
<template lang="html">
  <div class="h-100 pa3">
    <div class="tc pl-title mb3">
      Submission
    </div>
    <div class="mh3 pa3 flex-grow" >
      <div class="flex justify-center mb2">
        <i class="far fa-comment-alt fa-3x ma3"></i>
      </div>
      <p class="pl-subheading tl">
        Each student submits a unique response to the prompt before joining the discussion.
        Responses can include text, images, videos and hyperlinks.
      </p>
    </div>
    <div class="flex justify-center">
      <pl-button @click.native="$emit('close')" class="pl-primary"> Got it! </pl-button>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
      };
    },
  };
</script>
<style scoped lang="stylus">
  @import '~app/global-stylus.styl'
</style> -->



// WEBPACK FOOTER //
// onlineWalkthroughSubmissionCard.vue?0ff786c0